import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { DEFAULT_LOGO_ICON_URL } from "../config/brand-assets";

export default function StorageDisabledPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-4">
      <div className="max-w-4xl w-full">
        <div className="bg-white dark:bg-gray-800 shadow-xl rounded-lg p-4 sm:p-6 md:p-8">
          {/* Header */}
          <div className="text-center mb-6">
            <div className="flex items-center justify-center gap-3 mb-3">
              <img
                src={DEFAULT_LOGO_ICON_URL}
                alt="Viraly Logo"
                className="h-10 sm:h-12 w-auto"
              />
              <ExclamationTriangleIcon className="h-10 sm:h-12 w-10 sm:w-12 text-red-500 dark:text-red-400" />
            </div>
            <h1 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">
              Browser Storage Required
            </h1>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Viraly requires browser storage (cookies and local storage) to function properly
            </p>
          </div>

          {/* Two column layout on larger screens */}
          <div className="grid md:grid-cols-2 gap-4 mb-6">
            {/* Why section */}
            <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
              <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-3">
                Why is this required?
              </h2>
              <ul className="space-y-1.5 text-sm text-gray-600 dark:text-gray-400">
                <li>• Keep you signed in securely</li>
                <li>• Remember your preferences</li>
                <li>• Save your work and session data</li>
                <li>• Connect to social media accounts</li>
              </ul>
            </div>

            {/* How to enable - compact version */}
            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
              <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-3">
                How to enable storage
              </h2>

              <div className="space-y-2.5 text-sm text-gray-600 dark:text-gray-400">
                <div>
                  <div className="font-medium text-gray-900 dark:text-gray-100 mb-1">Chrome / Edge</div>
                  <p className="text-xs">Settings → Privacy and security → Cookies → Allow all cookies</p>
                </div>

                <div>
                  <div className="font-medium text-gray-900 dark:text-gray-100 mb-1">Safari</div>
                  <p className="text-xs">Settings → Privacy → Uncheck "Block all cookies"</p>
                </div>

                <div>
                  <div className="font-medium text-gray-900 dark:text-gray-100 mb-1">Firefox</div>
                  <p className="text-xs">Settings → Privacy & Security → Allow cookies</p>
                </div>

                <div className="pt-1 border-t border-blue-200 dark:border-blue-800">
                  <div className="font-medium text-gray-900 dark:text-gray-100 mb-1">Incognito / Private Mode</div>
                  <p className="text-xs">Try using a regular browser window instead</p>
                </div>
              </div>
            </div>
          </div>

          {/* Action button */}
          <div className="text-center">
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center px-6 py-2.5 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
            >
              Reload Page
            </button>
            <p className="mt-3 text-xs text-gray-500 dark:text-gray-400">
              After enabling storage, click above to reload
            </p>
          </div>
        </div>

        {/* Support link */}
        <div className="mt-4 text-center">
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Need help?{" "}
            <a
              href="mailto:support@viraly.io"
              className="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 underline"
            >
              Contact Support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
